import { logoutApp } from "@/apis/auth.api";
import { TokenKey, UserInfoKey } from "@/constants";
import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { useNavigate } from "react-router-dom";

export function useLogoutBehavior(showSuccessMessage = true) {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { mutate: logout, isPending } = useMutation({
    mutationFn: () => logoutApp(),
    onSuccess: () => {
      localStorage.removeItem(TokenKey);
      localStorage.removeItem(UserInfoKey);

      navigate("/login");

      showSuccessMessage && message.success("退出成功");
    },
  });

  return { logout, logoutPending: isPending };
}
